import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c3bbbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TripsTMSFilters__holder" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "TripsTMSFilters",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Оператор",
        loading: _ctx.data_state.operators.is_loading,
        failed: _ctx.data_state.operators.is_failed,
        disabled: _ctx.loading,
        "search-without-refresh": "",
        options: _ctx.data_state.operators.list,
        value: _ctx.state.operatorEmail,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.operatorEmail) = $event)),
        "select-by": "email",
        onRefresh: _ctx.loadOperators,
        onLoadmore: _ctx.loadMoreOperators,
        onSearch: _ctx.searchOperators,
        onOptionBySearch: _ctx.unshiftFindedOperator
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh", "onLoadmore", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата с",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.periodFrom,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.periodFrom) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата по",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.periodTo,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.periodTo) = $event))
      }, null, 8, ["disabled", "value"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--search mr-3",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--reset",
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ], 32))
}